import React from "react";
import Navbar from "../components/site/Navbar";
import Footer from "../components/site/Footer";
import FinalCTA from "../components/site/FinalCTA";
import { PageHead } from "../components/site/Section";
import { Icon } from "../components/site/Icons";
import StepsDemo from "../components/site/StepsDemo";
import { FEATURE_GROUPS } from "../data/content";

function Chips({ item }) {
  if (item.chips) {
    return item.chips.map(([label, kind]) => <span key={label} className={`plan-chip ${kind}`}>{label}</span>);
  }
  return item.plan === "pro"
    ? <span className="plan-chip pro">Pro</span>
    : <span className="plan-chip all">Starter and Pro</span>;
}

export default function Features() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <PageHead kicker="Bar stock control features" title="Everything Barlo does, and which plan it's on"
          lede="Built for a busy shift: count on your phone, order in one go, and see the money behind your stock. Every feature is in the 14-day trial.">
          <div className="legend" style={{ marginTop: 22 }}>
            <span className="plan-chip all">Starter and Pro</span><span className="plan-chip pro">Pro</span>
          </div>
        </PageHead>
        <StepsDemo />
        <section style={{ paddingTop: 0 }}>
          <div className="wrap">
            {FEATURE_GROUPS.map((g, gi) => (
              <div key={g.title}>
                <div className="group-title" style={gi === 0 ? { marginTop: 0 } : undefined}><h2>{g.title}</h2></div>
                <div className="fgrid">
                  {g.items.map((it) => (
                    <article className="fcard" key={it.title} data-testid={`feature-${it.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                      <span className="ficon"><Icon name={it.icon} /></span>
                      <h3>{it.title}</h3>
                      <p>{it.body}</p>
                      <div className="chips"><Chips item={it} /></div>
                    </article>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>
        <FinalCTA testidTrial="features-cta-trial" />
      </main>
      <Footer />
    </div>
  );
}
